<template style="height: 100%">
  <article class="message menuCreateFrp">
    <div class="message-body panel-body">
      <div class="panel-scroll">
      <div class="has-text-right">
        <button class="delete" aria-label="delete" v-on:click="close"></button>
      </div>
      <!-- First part -->
      <div class="has-text-centered">
        <!-- Title -->
        <div
          class="heading is-size-6 border"
          style="padding-top: 5px; margin-top: 5px; text-transform: capitalize;"
        >
          <!-- Text -->
          <div class="is-size-2">
            {{ this.process._id ? "Actualizar" : "Crear" }} Proceso
          </div>
        </div>
      </div>
      <br />
      <div class="box">
        <span class="is-size-7"
          >Los siguientes datos solicitados en el formulario se usará para
          construir el nombre del proceso. Ingresa la fecha correcta del
          proceso, con ello identificaremos los procesos más actualizados.</span
        >
      </div>
      <div style="margin-top: 25px;">
        <div>
          <label for="name"
            >Nombre del proceso<span class="has-text-dark has-text-weight-bold"
              >*</span
            ></label
          >
          <div class="field">
            <div class="control">
              <input
                class="input"
                :class="errors.name.type"
                v-model="process.name"
                type="text"
                id="name"
                name="name"
                placeholder="Nombre del nuevo proceso"
              />
            </div>
          </div>
          <span
            v-if="errors.name.message"
            class="is-size-7 has-text-danger"
            style="margin-top: -5px"
            >{{ errors.name.message }}</span
          >
        </div>
        <br />
        <div class="columns">
          <div class="column is-6">
            <label for="group"
              >Nombre del grupo<span class="has-text-dark has-text-weight-bold"
                >*</span
              ></label
            >
            <div class="field">
              <div class="control">
                <input
                  class="input"
                  :class="errors.group.type"
                  v-model="process.group"
                  type="text"
                  id="group"
                  name="group"
                  placeholder="Nombre del grupo"
                />
              </div>
            </div>
            <span
              v-if="errors.group.message"
              class="is-size-7 has-text-danger"
              style="margin-top: -5px"
              >{{ errors.group.message }}</span
            >
          </div>
          <div class="column is-6">
            <label for="created"
              >Fecha de creación<span class="has-text-dark has-text-weight-bold"
                >*</span
              ></label
            >
            <div class="field">
              <div class="control">
                <input
                  class="input"
                  :class="errors.created.type"
                  type="date"
                  v-model="process.created"
                  id="created"
                  name="created"
                  placeholder="Fecha de creación"
                />
              </div>
            </div>
            <span
              v-if="errors.created.message"
              class="is-size-7 has-text-danger"
              style="margin-top: -5px"
              >{{ errors.created.message }}</span
            >
          </div>
        </div>
        <div style="margin-top: 5px;">
          <div class="field">
            <div class="file is-link is-boxed has-name">
              <label class="file-label" style="width: 100% !important;">
                <input
                  ref="inputFile"
                  class="file-input"
                  type="file"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  name="data"
                  v-on:change="onFileChange"
                />
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="material-icons">file_upload</i>
                  </span>
                  <span class="file-label">
                    Subir datos... {{ process._id ? "" : "*" }}
                  </span>
                </span>
                <span
                  class="file-name has-text-centered"
                  style="width: 100% !important; max-width: 100% !important"
                >
                  <span class="is-size-7">{{ file.name }}</span>
                </span>
              </label>
            </div>
            <span
              v-if="errors.data.message"
              class="is-size-7 has-text-danger"
              style="margin-top: -5px"
              >{{ errors.data.message }}</span
            >
            <div style="margin-top: 10px">
              <span class="is-size-7"
                >Recuerda subir los datos con la estructura especificada.
                <a href="#" @click.prevent="downloadTemplate" class="has-text-dark"
                  >aquí</a
                ></span
              >
            </div>
          </div>
          <br />
          <b-field label="Benchmark" style="margin-top: 10px;">
            <b-radio-button
              v-model="process.benchmark"
              :native-value="0"
              type="is-danger"
            >
              <b-icon icon="database-minus-outline"></b-icon>
              Excluido
            </b-radio-button>
            <b-radio-button
              v-model="process.benchmark"
              :native-value="1"
              type="is-success"
            >
              <b-icon icon="database-plus-outline"></b-icon>
              Incluido
            </b-radio-button>
          </b-field>
          <div style="margin-top: 18px;">
            <label class="label" style="margin-bottom: 2px;">
              Subtotal intralaboral por forma (opcional)
            </label>
            <p
              class="is-size-7 has-text-grey"
              style="margin-bottom: 8px; line-height: 1.3;"
            >
              Complétalo sólo si el Excel del informe NO incluye las columnas
              <strong>TOTAL INTRA TRANSFORMA A/B</strong>. Ingresa el promedio
              intralaboral de cada forma; el nivel de riesgo y la periodicidad se
              calculan automáticamente.
            </p>
            <b-field grouped>
              <b-field label="Forma A" custom-class="is-small" expanded>
                <b-input
                  v-model="process.formaIntra.A"
                  type="number"
                  step="0.01"
                  min="0"
                  max="100"
                  placeholder="Ej. 22.5"
                />
              </b-field>
              <b-field label="Forma B" custom-class="is-small" expanded>
                <b-input
                  v-model="process.formaIntra.B"
                  type="number"
                  step="0.01"
                  min="0"
                  max="100"
                  placeholder="Ej. 24.1"
                />
              </b-field>
            </b-field>
          </div>
        </div>
      </div>
      </div>
      <div class="actions-footer has-background-white">
        <div class="is-flex">
          <button
            class="button is-danger is-outlined"
            style="margin-right: 5px"
            v-on:click="close"
          >
            Cancelar
          </button>
          <button
            class="button is-dark"
            :disabled="saving"
            v-on:click="createNewProcess"
          >
            {{
              saving
                ? "Guardando..."
                : process._id
                ? "Actualizar"
                : "Guardar"
            }}
          </button>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import * as XLSX from "xlsx";
import apiServices from "@/services/yungol-services";
import { RGO_COLUMNS, TRANSFORMA_COLUMNS, generateFrpTemplate } from "../helpers";

export default {
  data() {
    return {
      file: {
        name: "...",
        dataFile: null,
        filesAccept: [
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
        ],
        columnsValid: [...RGO_COLUMNS, ...TRANSFORMA_COLUMNS],
      },
      process: {
        name: "",
        group: "",
        data: null,
        created: null,
        benchmark: 0,
        formaIntra: { A: null, B: null },
      },
      errors: {
        name: {},
        group: {},
        data: {},
        created: {},
      },
      errorsCont: 0,
      saving: false,
    };
  },
  props: {
    data: Object,
    hasBenchmark: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    close() {
      this.$emit("closeMenuCreate");
    },
    downloadTemplate() {
      generateFrpTemplate();
    },
    async createNewProcess() {
      if (this.saving) return;
      const _this = this;
      const config = {
        title: "¿Estás seguro?",
        // text: "Se guardara un proceso ",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#de5b5b",
        confirmButtonText: `Sí, ${this.process._id ? "actualizar" : "guardar"}`,
      };

      try {
        if (this.validateForm()) {
          if (this.hasBenchmark && this.process.benchmark === 1) {
            const config = {
              title: "¿Estás seguro?",
              text:
                "Ya hay un proceso seleccionado para el benchmark. Si continúas, este proceso lo reemplazará.",
              icon: "warning",
              showCancelButton: true,
              cancelButtonColor: "#de5b5b",
              confirmButtonText: "Sí, reemplazar proceso",
            };

            await this.$swal(config).then(async (result) => {
              if (!result.isConfirmed) {
                this.process.benchmark = 0;
              }
            });
          }
          this.saving = true;
          this.$swal(config).then((result) => {
            if (result.isConfirmed) {
              const file = _this.file.dataFile;
              let task;
              if (file) {
                task = _this.$fire.refexcel(file);
                this.$store.dispatch("notify", {
                  message: "Cargando datos...",
                });
                task.on(
                  "state_changed",
                  () => {
                    // Cargador...
                  },
                  (err) => {
                    this.$store.dispatch("notify", {
                      message: "Error!. No se pudo subir los datos.",
                      type: "is-danger",
                    });
                    console.log("error subiendo el archivo", err);
                    _this.saving = false;
                  },
                  async () => {
                    try {
                      const url = await task.snapshot.ref.getDownloadURL();
                      _this.process.data = url;
                      const data = {
                        name: `${_this.process.name} - ${
                          _this.process.group
                        } - ${_this.formatDateForName(_this.process.created)}`,
                        newProcess: _this.process,
                      };

                      if (url) {
                        await apiServices
                          .post(`/savefrp`, data)
                          .then(async (res) => {
                            if (res.data) {
                              _this.validateColumns(res.data.data);
                              await _this.$store.dispatch("notify", {
                                message: `Perfecto!. Proceso ${
                                  _this.process._id ? "Editado" : "Creado"
                                }.`,
                              });
                              _this.clearAllForm();
                              _this.$emit("getProcesses");
                              _this.close();
                            }
                            _this.saving = false;
                          })
                          .catch(async (err) => {
                            this.$store.dispatch("notify", {
                              message: "Error!. No se pudo subir los datos.",
                              type: "is-danger",
                            });
                            console.log("Ocurrio un error: ", err);
                            _this.saving = false;
                          });
                      } else {
                        this.$store.dispatch("notify", {
                          message: "Error!. No se pudo subir los datos.",
                          type: "is-danger",
                        });
                        console.log("Ocurrio un error: no se genero url");
                        _this.saving = false;
                      }
                    } catch (err) {
                      this.$store.dispatch("notify", {
                        message: "Error!. No se pudo subir los datos.",
                        type: "is-danger",
                      });
                      console.log("Ocurrio un error: ", err);
                      _this.saving = false;
                    }
                  },
                );
              } else {
                const data = {
                  name: `${_this.process.name} - ${
                    _this.process.group
                  } - ${_this.formatDateForName(_this.process.created)}`,
                  newProcess: _this.process,
                };

                apiServices
                  .post(`/savefrp`, data)
                  .then(async (res) => {
                    if (res.data) {
                      _this.validateColumns(res.data.data);
                      await _this.$store.dispatch("notify", {
                        message: `Perfecto!. Proceso ${
                          _this.process._id ? "Editado" : "Creado"
                        }.`,
                      });
                      _this.clearAllForm();
                      _this.$emit("getProcesses");
                      _this.close();
                    }
                    _this.saving = false;
                  })
                  .catch(async (err) => {
                    this.$store.dispatch("notify", {
                      message: "Error!. No se pudo subir los datos.",
                      type: "is-danger",
                    });
                    console.log("Ocurrio un error: ", err);
                    _this.saving = false;
                  });
              }
            } else {
              _this.saving = false;
            }
          });
        }
      } catch (err) {
        console.log(err);
        this.saving = false;
      }
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (!this.file.filesAccept.includes(files[0].type))
        return this.errorFile();

      const selectedFile = files[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        const wb = XLSX.read(event.target.result, { type: "array" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(ws, { header: 1 });

        if (rows.length <= 1) {
          this.$store.dispatch("notify", {
            message:
              "El archivo no tiene filas de datos. Agrega al menos un colaborador antes de subirlo.",
            type: "is-danger",
          });
          if (this.$refs.inputFile) this.$refs.inputFile.value = null;
          return;
        }

        this.file.dataFile = selectedFile;
        this.file.name = selectedFile.name;
        this.process.data = "cargando...";
      };
      reader.readAsArrayBuffer(selectedFile);
    },
    validateForm() {
      this.errors = {
        name: {},
        group: {},
        data: {},
        created: {},
      };
      const process = this.process;
      let valid = true;
      if (process.name === "" || process.name === null) {
        this.errors.name.message = "El nombre es requerido.";
        this.errors.name.type = "is-danger";
        valid = false;
      }
      if (process.group === "" || process.group === null) {
        this.errors.group.message = "El grupo es requerido.";
        this.errors.group.type = "is-danger";
        valid = false;
      }
      if ((process.data === "" || process.data === null) && !this.process._id) {
        this.errors.data.message = "Los datos son requeridos.";
        this.errors.data.type = "is-danger";
        valid = false;
      }
      if (process.created === "" || process.created === null) {
        this.errors.created.message = "La fecha es requerida.";
        this.errors.created.type = "is-danger";
        valid = false;
      }
      if (!valid) {
        this.errorsCont++;
      }
      return valid;
    },
    validateColumns(data) {
      const errorColumns = [];
      const keys = Object.keys(data);

      for (const k of this.file.columnsValid) {
        if (!keys.includes(k)) errorColumns.push(k);
      }

      if (errorColumns.length) {
        const config = {
          title: "Datos guardados",
          html: `Al guardar se encontraron errores en las columnas: <br/> <br/> ${errorColumns
            .toString()
            .replace(",", "<br/>")}`,
          icon: "warning",
        };

        this.$swal(config);
      }

      return errorColumns.length;
    },
    clearAllForm() {
      this.process = {
        name: "",
        group: "",
        data: null,
        created: null,
        benchmark: 0,
        formaIntra: { A: null, B: null },
      };
      this.errors = {
        name: {},
        group: {},
        data: {},
        created: {},
      };
      this.errorsCont = 0;
    },
    errorFile() {
      this.$store.dispatch("notify", {
        message: `El archivo solo puede ser tipo Excel`,
        type: "is-danger",
      });
      this.deleteFile();
    },
    formatDateForName(d) {
      let date = new Date(d);
      date.setHours(date.getHours() + 12);
      let options = { day: "numeric", month: "long", year: "numeric" };
      date = date.toLocaleDateString(undefined, options);
      return date;
    },
  },
  created() {
    if (Object.keys(this.data).length) {
      const { id, nombre, created, benchmark, formaIntraManual } = this.data;
      const [name, group] = nombre.split(" - ");
      const fi = formaIntraManual || {};
      this.process = {
        _id: id,
        name: name || "",
        group: group || "",
        data: null,
        created: created ? created.split("T")[0] : null,
        benchmark: benchmark || 0,
        formaIntra: {
          A: fi.A != null ? fi.A : null,
          B: fi.B != null ? fi.B : null,
        },
      };
    }
  },
  watch: {
    process: {
      handler() {
        if (this.errorsCont) {
          this.validateForm();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.menuCreateFrp {
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  @media screen and (min-width: 1280px) {
    width: 30%;
  }
  height: 100%;
  position: fixed;
  background: white;
  z-index: 251;
  top: 0;
  right: 0;
  overflow: hidden;
  border-radius: 0 0 0 0 !important;
}

/* Panel is a vertical flex column: a scrollable content area on top and a
   footer pinned below it that never overlaps the fields. */
.menuCreateFrp .panel-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;
}

.menuCreateFrp .panel-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 1.25rem 1.5rem;
}

.menuCreateFrp .actions-footer {
  flex: 0 0 auto;
  padding: 12px 1.5rem;
  border-top: 1px solid #ededed;
}

.menuCreateFrp .field {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/components/menuCreateFrp.vue